<!-- START Sidebar (left)-->
<div class="aside-inner">
  <nav class="sidebar">
    <!-- START sidebar nav-->
    <ul class="sidebar-nav">
      <!-- START user info-->
      <li class="has-user-block">
        <app-userblock></app-userblock> 
      </li> 
      <li [routerLinkActive]="['active']">
        <a [routerLink]="['/home']">
          <em class="fas dash-icon"></em>
          <p style="vertical-align: text-bottom;margin-bottom: 3px !important;">Home</p>
        </a>
      </li> 
       <li>
        <a [routerLink]="['/pos/pos']">
          <em class="fas  manage-icon "></em>
          <p style="vertical-align: text-bottom;margin-bottom: 3px !important;">POS Home</p>
        </a>
      </li>
      <li [routerLinkActive]="['active']">
        <a [routerLink]="['/pos/businessinfo']">
          <em class="fas  manage-icon "></em>
          <p style="vertical-align: text-bottom;margin-bottom: 3px !important;">Manage </p>
        </a>
      </li>
     
      <li [routerLinkActive]="['active']">
        <a  [routerLink]="['/pos/orders/new']">
          <em class="fas  manage-icon "></em>
          <p style="vertical-align: text-bottom;margin-bottom: 3px !important;">Point of Sale</p>
        </a>
        
      </li>
      <li [routerLinkActive]="['active']">
        <a  [routerLink]="['/pos/guide']">
          <em style="color: #fff;" class="fas fa-info-circle"></em>
          <p style="vertical-align: text-bottom;margin-bottom: 3px !important;">Guide</p>
        </a>
        
      </li>
      <li [routerLinkActive]="['active']">
        <a  [routerLink]="['/pos/download']">
          <em class="fas fa-download"></em>
          <p style="vertical-align: text-bottom;margin-bottom: 3px !important;">Mobile App</p>
        </a>
        
      </li>
    </ul> 

  </nav>
</div> 